import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { HeroIconModule } from "../icons/heroIcon.module";
import { LoggingModule } from "../logging/logging.module";
import { MaterialModule } from "../material/material.module";
import { SharedModule } from "../shared/shared.module";
import { ProvisionUserComponent } from "../padlock/provision-user/provision-user.component";
import { UserNavComponent } from "./user-nav/user-nav.component";

@NgModule({
  declarations: [UserNavComponent, ProvisionUserComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    LoggingModule,
    HeroIconModule,
    MaterialModule,
    SharedModule,
  ],
  exports: [UserNavComponent, ProvisionUserComponent],
})
export class UserShellModule {}
